<template>
	<g>
		<rect x="331.2" y="420.6" fill="#A4A9AD" width="84.6" height="73.8"/>
		<rect x="339.1" y="444.5" opacity="0.1" enable-background="new    " width="36.3" height="17.5"/>
		<rect x="379.5" y="467.8" opacity="0.1" enable-background="new    " width="36.3" height="17.5"/>
		<rect x="331.2" y="420.6" opacity="0.1" enable-background="new    " width="84.6" height="19.8"/>
		<path fill="#D68231" d="M423.4,413.7c0-2.3-1.9-4.2-4.2-4.2h-91.3c-2.3,0-4.2,1.9-4.2,4.2v13.9c0,2.3,1.9,4.2,4.2,4.2h91.3
	c2.3,0,4.2-1.9,4.2-4.2V413.7z"/>
		<g id="IconFactory--groupsteam1">
			<circle id="IconFactory--steam1" fill="#D1D3D3" cx="295.6" cy="202.3" r="39.8"/>
			<circle id="IconFactory--steam2" fill="#D1D3D3" cx="295.6" cy="166.6" r="33.8"/>
			<circle id="IconFactory--steam3" fill="#D1D3D3" cx="295.6" cy="132.9" r="33.8"/>
			<circle id="IconFactory--steam4" fill="#D1D3D3" cx="295.6" cy="108.8" r="41.6"/>
			<circle id="IconFactory--steam5" fill="#D1D3D3" cx="295.6" cy="62" r="33.8"/>
			<circle id="IconFactory--steam6" fill="#D1D3D3" cx="295.6" cy="18.3" r="33.8"/>
		</g>
		<g id="IconFactory--groupsteam2">
			<circle id="IconFactory--steam1" fill="#D1D3D3" cx="295.6" cy="202.3" r="39.8"/>
			<circle id="IconFactory--steam2" fill="#D1D3D3" cx="295.6" cy="166.6" r="33.8"/>
			<circle id="IconFactory--steam3" fill="#D1D3D3" cx="295.6" cy="132.9" r="33.8"/>
			<circle id="IconFactory--steam4" fill="#D1D3D3" cx="295.6" cy="108.8" r="41.6"/>
			<circle id="IconFactory--steam5" fill="#D1D3D3" cx="295.6" cy="62" r="33.8"/>
			<circle id="IconFactory--steam6" fill="#D1D3D3" cx="295.6" cy="18.3" r="33.8"/>
		</g>
		<circle id="IconFactory--steamBug" fill="#D1D3D3" cx="295.6" cy="202.3" r="39.8"/>
		<g id="IconFactory--factory">
			<polygon fill="#333E48" points="335.4,210.1 255.7,210.1 238.1,494.4 353,494.4 "/>
			<path fill="#D68231" d="M339.7,279.1h-88.3l-0.8,12.6h89.8L339.7,279.1z M338.1,253.6H253l-0.8,12.6h86.7L338.1,253.6z"/>
		</g>
		<rect x="96.7" y="337.2" fill="#A4A9AD" width="216.4" height="157.2"/>
		<rect x="276.9" y="437" opacity="0.1" enable-background="new    " width="36.3" height="17.5"/>
		<rect x="96.6" y="415.8" opacity="0.1" enable-background="new    " width="36.3" height="17.5"/>
		<rect x="220" y="350.2" opacity="0.1" enable-background="new    " width="36.3" height="17.5"/>
		<rect x="141.6" y="337.2" opacity="0.1" enable-background="new    " width="36.3" height="17.5"/>
		<rect x="127.8" y="462" opacity="0.1" enable-background="new    " width="36.3" height="17.5"/>
		<path opacity="0.1" enable-background="new    " d="M291.7,389c0-4.6-3.8-8.4-8.4-8.4H126.6c-4.6,0-8.4,3.8-8.4,8.4v15.4
	c0,4.6,3.8,8.4,8.4,8.4h156.7c4.6,0,8.4-3.8,8.4-8.4V389z"/>
		<path fill="#FFFFFF" d="M291.7,376c0-4.6-3.8-8.4-8.4-8.4H126.6c-4.6,0-8.4,3.8-8.4,8.4v15.4c0,4.6,3.8,8.4,8.4,8.4h156.7
	c4.6,0,8.4-3.8,8.4-8.4V376z"/>
		<path opacity="0.1" enable-background="new    " d="M283.3,367.6H126.6c-4.6,0-8.4,3.8-8.4,8.4v10.7c0-4.6,3.8-8.4,8.4-8.4h156.7
	c4.6,0,8.4,3.8,8.4,8.4V376C291.7,371.4,287.9,367.6,283.3,367.6z"/>
		<g>
			<path fill="#D1D3D3" d="M96.7,304.5c0,2.9,0,32.7,0,32.7h36.1c0,0-31.7-31.7-32.8-32.8C98.7,303.1,96.7,302.4,96.7,304.5z"/>
			<path fill="#D1D3D3" d="M132.8,304.5c0,2.9,0,32.7,0,32.7h36.1c0,0-31.7-31.7-32.8-32.8C134.8,303.1,132.8,302.4,132.8,304.5z"/>
			<path fill="#D1D3D3" d="M168.8,304.5c0,2.9,0,32.7,0,32.7h36.1c0,0-31.7-31.7-32.8-32.8C170.8,303.1,168.8,302.4,168.8,304.5z"/>
			<path fill="#D1D3D3" d="M204.9,304.5c0,2.9,0,32.7,0,32.7H241c0,0-31.7-31.7-32.8-32.8C206.9,303.1,204.9,302.4,204.9,304.5z"/>
			<path fill="#D1D3D3" d="M241,304.5c0,2.9,0,32.7,0,32.7h36.1c0,0-31.7-31.7-32.8-32.8C243,303.1,241,302.4,241,304.5z"/>
			<path fill="#D1D3D3" d="M277.1,304.5c0,2.9,0,32.7,0,32.7h36.1c0,0-31.7-31.7-32.8-32.8C279.1,303.1,277.1,302.4,277.1,304.5z"/>
			<rect x="154.7" y="429.5" fill="#D1D3D3" width="100.4" height="64.9"/>
		</g>
		<g opacity="0.1">
			<rect x="154.7" y="442.9" width="100.4" height="12.6"/>
		</g>
		<g opacity="0.1">
			<rect x="154.7" y="466.8" width="100.4" height="12.6"/>
		</g>
		<g>
			<rect x="153.4" y="367.6" fill="#A4A9AD" width="12.6" height="32.1"/>
			<rect x="198.6" y="367.6" fill="#A4A9AD" width="12.6" height="32.1"/>
			<rect x="243.8" y="367.6" fill="#A4A9AD" width="12.6" height="32.1"/>
		</g>
		<path fill="#D68231" d="M283.3,406H126.6c-8.1,0-14.7-6.6-14.7-14.7V376c0-8.1,6.6-14.7,14.7-14.7h156.7c8.1,0,14.7,6.6,14.7,14.7
	v15.4C297.9,399.5,291.4,406,283.3,406z M126.6,373.9c-1.1,0-2.1,1-2.1,2.1v15.4c0,1.1,1,2.1,2.1,2.1h156.7c1.1,0,2.1-1,2.1-2.1V376
	c0-1.1-1-2.1-2.1-2.1H126.6z"/>
		<path fill="#333E48" d="M461.1,507.6c0,1.9-1.5,3.4-3.4,3.4H71.9c-1.9,0-3.4-1.5-3.4-3.4v-12.1c0-1.9,1.5-3.4,3.4-3.4h385.8
	c1.9,0,3.4,1.5,3.4,3.4L461.1,507.6L461.1,507.6z"/>
	</g>
</template>

<script>

	import { TimelineMax, TweenMax, Power0 } from 'gsap'

	export default {
		name: "IconFactory.vue",
		data: function () {
			return {
				tl:undefined,
				animSmoke:[]
			}
		},

		methods: {
			start() {

				this.tl = new TimelineMax({repeat: -1});
				this.animSmoke[0] = TweenMax.to('#IconFactory--steam1', 1, {scale: 1.1, repeat: -1, yoyo: true, transformOrigin:"center"});
				this.animSmoke[1] = TweenMax.to('#IconFactory--steam2', 0.75, {scale: 1.1, repeat: -1, yoyo: true, transformOrigin:"center"});
				this.animSmoke[2] = TweenMax.to('#IconFactory--steam3', 1.2, {scale: 1.1, repeat: -1, yoyo: true, transformOrigin:"center"});
				this.animSmoke[3] = TweenMax.to('#IconFactory--steam4', 1.5, {scale: 0.8  , repeat: -1, yoyo: true, transformOrigin:"center"});
				this.animSmoke[4] = TweenMax.to('#IconFactory--steam5', 0.85, {scale: 1.1, repeat: -1, yoyo: true, transformOrigin:"center"});
				this.animSmoke[5] = TweenMax.to('#IconFactory--steam6', 0.7, {scale: 1.1, repeat: -1, yoyo: true, transformOrigin:"center"});

				this.tl.set('#IconFactory--groupsteam2', {y: 250});
				this.tl.set('#IconFactory--steamBug', {y: 20});
				this.tl.to('#IconFactory--groupsteam1', 3, {y: -250, ease: Power0.easeNone});
				this.tl.to('#IconFactory--groupsteam2', 3, {y: 0, ease: Power0.easeNone}, '-=3');
				this.tl.to('#IconFactory--steamBug', 3, {y: -230, ease: Power0.easeNone}, '-=3');

				this.animSmoke[6] =  TweenMax.to('#IconFactory--factory', 1, {scale: 1.1, ease: Power0.easeNone, transformOrigin:"center", repeat: -1, yoyo: true});
			},
			stop() {
				this.tl.kill();
				for (var t = 0; t < this.animSmoke.length; t++) {
					this.animSmoke[t].kill();
				}
			},
			pause() {
				this.tl.pause();
				for (var t = 0; t < this.animSmoke.length; t++) {
					this.animSmoke[t].pause();
				}
			},
			play() {
				if (this.tl.paused()) {
					this.tl.play();
				}
				for (var t = 0; t < this.animSmoke.length; t++) {
					if (this.animSmoke[t].paused()) {
						this.animSmoke[t].play();
					}
				}
			}
		}
	}
</script>

<style scoped>

</style>
